import * as T from "types";

// Ordered group definitions with matching functions
export const CHANNEL_GROUPS = [
  {
    key: T.EChannelGroup.PRODUCTION,
    label: "Production Channels",
    match: (c: string) => c.endsWith("production"),
  },
  {
    key: T.EChannelGroup.MANUFACTURING,
    label: "Manufacturing Channels",
    match: (c: string) => c.includes("cm") || c.includes("manufacturing"),
  },
  {
    key: T.EChannelGroup.PREVIEW,
    label: "Preview Channels",
    match: (c: string) => c.includes("-preview") || c === "production-preview",
  },
  {
    key: T.EChannelGroup.RC,
    label: "Release Candidate Channels",
    match: (c: string) => c.includes("-rc") || c === "production-rc",
  },
  {
    key: T.EChannelGroup.BETA,
    label: "Beta Channels",
    match: (c: string) => c.includes("beta"),
  },
  {
    key: T.EChannelGroup.DEV,
    label: "Development Channels",
    match: (c: string) => c.includes("-dev"),
  },
  {
    key: T.EChannelGroup.OTHER,
    label: "Other Channels",
    match: (_c: string) => true,
  },
];

export const groupChannelsByCategory = (
  channels: string[]
): T.IChannelGroups => {
  const out: T.IChannelGroups = {} as T.IChannelGroups;
  for (const group of CHANNEL_GROUPS) {
    out[group.key] = {
      label: group.label,
      channels: new Set<string>(),
    };
  }

  for (const channel of channels) {
    for (const group of CHANNEL_GROUPS) {
      if (group.match(channel)) {
        out[group.key].channels.add(channel);
        break;
      }
    }
  }

  return out;
};

export const sortChannels = (a: string, b: string) => {
  const a1 = a.toLowerCase();
  const b1 = b.toLowerCase();
  return a1.localeCompare(b1);
};

export const isOldChannel = (
  flatArchivedChannels: string[],
  channel: string
) => {
  return flatArchivedChannels.includes(channel);
};
